import { Locales, LocalesStrings } from '../types/locales'

export const localesMap = {
    0: LocalesStrings.NL,
    1: LocalesStrings.EN,
}

export const localesStringMap = {
    [LocalesStrings.NL]: 0 satisfies Locales,
    [LocalesStrings.EN]: 1 satisfies Locales,
}
